import { render, staticRenderFns } from "./SetUi.vue?vue&type=template&id=4c0cb932&lang=pug"
import script from "./SetUi.vue?vue&type=script&lang=js"
export * from "./SetUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports